'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alphabetic = require('./alphabetic');

var _alphabetic2 = _interopRequireDefault(_alphabetic);

var _numeric = require('./numeric');

var _byLastName = require('./byLastName');

var _byLastName2 = _interopRequireDefault(_byLastName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  alphabetic: _alphabetic2.default, numeric: _numeric.numeric, numericReverse: _numeric.numericReverse, byLastName: _byLastName2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/sorting/compareFns/index.js
// module id = 935
// module chunks = 0